import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Building2, Briefcase } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  data: {
    org_name: string;
    org_type: "entreprise" | "cabinet" | "";
    org_address: string;
    org_email: string;
    org_website: string;
    org_siret: string;
  };
  onChange: (field: string, value: string) => void;
}

export function StepOrganisation({ data, onChange }: Props) {
  return (
    <div className="space-y-4">
      {/* Type selector */}
      <div className="space-y-2">
        <Label>Type d'organisation <span className="text-destructive">*</span></Label>
        <div className="grid grid-cols-2 gap-3">
          {(["entreprise", "cabinet"] as const).map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => onChange("org_type", type)}
              className={cn(
                "flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all text-sm font-medium",
                data.org_type === type
                  ? "border-primary bg-primary/5 text-primary"
                  : "border-border hover:border-muted-foreground/40 text-muted-foreground"
              )}
            >
              {type === "entreprise" ? (
                <Building2 className="w-6 h-6" />
              ) : (
                <Briefcase className="w-6 h-6" />
              )}
              {type === "entreprise" ? "Entreprise" : "Cabinet comptable"}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="org_name">Nom de l'organisation <span className="text-destructive">*</span></Label>
        <Input
          id="org_name"
          value={data.org_name}
          onChange={(e) => onChange("org_name", e.target.value)}
          placeholder="Ex: SARL Exemple ou Cabinet XYZ & Associés"
          required
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="org_email">Email de l'organisation</Label>
          <Input
            id="org_email"
            type="email"
            value={data.org_email}
            onChange={(e) => onChange("org_email", e.target.value)}
            placeholder="contact@organisation.com"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="org_siret">N° RCCM / SIRET</Label>
          <Input
            id="org_siret"
            value={data.org_siret}
            onChange={(e) => onChange("org_siret", e.target.value)}
            placeholder="CI-ABJ-2024-B-XXXXX"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="org_website">Site web</Label>
        <Input
          id="org_website"
          type="url"
          value={data.org_website}
          onChange={(e) => onChange("org_website", e.target.value)}
          placeholder="https://www.organisation.com"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="org_address">Adresse</Label>
        <Textarea
          id="org_address"
          value={data.org_address}
          onChange={(e) => onChange("org_address", e.target.value)}
          placeholder="Adresse complète de l'organisation"
          rows={2}
        />
      </div>
    </div>
  );
}
